/**
 * Site configuration for the cloaking site
 * 
 * Environment variables:
 * - VITE_UTM_SOURCE: Tracking identifier for this domain (required per deployment)
 * - VITE_TARGET_URL: Where redirects go (defaults to pixelmaker.ai)
 * - VITE_API_URL: Backend API for models, templates, uploads
 */
export const SITE_CONFIG = {
  // Configurable per deployment - passed as ?utm_source=xxx in redirect URLs
  UTM_SOURCE: import.meta.env.VITE_UTM_SOURCE || 'cloak_site',

  // Configurable for endpoint changes (defaults to production)
  TARGET_URL: import.meta.env.VITE_TARGET_URL || 'https://pixelmaker.ai',
  API_URL: import.meta.env.VITE_API_URL || 'https://new.api.pixelmaker.ai',

  // PostHog analytics (optional)
  POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY || '',
  POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
} as const;
